import React from 'react'

import { Message } from '@/app/module/campaigns/types'

import { getMessagePersonalizationList } from '../../part-response-pz'
import MessageWrapper, { MessageWrapperProps } from './message-wrapper'

type Props = MessageWrapperProps & {
  messages: Record<string, Message>
  ordered: string[]
}

// Memoize personalization per part here because MessageWrapper is a class component.
const PartItem: React.FC<Props> = ({
  personalizationList: basePersonalizationList,
  id,
  messages,
  ordered,
  ...messageWrapperProps
}) => {
  const personalizationList = React.useMemo(
    () =>
      getMessagePersonalizationList({
        id,
        messages,
        ordered,
        personalizationList: basePersonalizationList,
      }),
    [basePersonalizationList, id, messages, ordered],
  )

  return <MessageWrapper {...messageWrapperProps} id={id} personalizationList={personalizationList} />
}

export default React.memo(PartItem)
